import * as React from 'react';
import { Checkbox, FormControl, HelpBlock, Radio } from 'react-bootstrap';
import * as Cleave from 'cleave.js/react';
import { CleaveOptions } from 'cleave.js/options';
// Work around the module being used in CJS and ES6 module formats.
// One module exports with a default, the other doesn't...
let MaskedInput = require('react-text-mask');

if (MaskedInput.default) {
  MaskedInput = MaskedInput.default;
}

interface IFieldFormControlProps {
  placeholder?: string;
  type: string;
  input?: any;
  componentClass?: string;
  className?: string;
  style?: React.CSSProperties;
  meta?: { touched: boolean; dirty: boolean; error: string };
  mask?: any;
  value?: string | number;
  complexValue?: boolean;
  simpleValue?: any;
  cleaveOptions?: any;
  onValueChange?: (newValue: any) => void;
}

const FieldFormControl = ({
  placeholder,
  type,
  input,
  componentClass,
  className = '',
  style,
  meta,
  mask,
  value,
  complexValue = false,
  simpleValue = null,
  cleaveOptions = null,
  ...props,
}: IFieldFormControlProps) => {
  const classes = className + (meta.dirty ? ' dirty-field' : '') + ' sessioncamhidetext';
  let component = null;
  let onBlur = input.onBlur;
  let onChange = (e: any) => {
    input.onChange(e);
    if (props.onValueChange) {
      const nextValue = e && e.target ? e.target.value : e;
      props.onValueChange(nextValue);
    }
  };

  if (complexValue) {
    onBlur = () => input.onBlur();
    onChange = () => {
      input.onChange(input.value);
      if (props.onValueChange) {
        props.onValueChange(input.value);
      }
    };
  }

  const complexProps = { onBlur, onChange, value: input.value };

  // if (complexValue) {
  //   complexProps.value = simpleValue;
  // }

  let options: CleaveOptions = null;

  switch (type) {
    case 'masked-date':
      options = {
        date: true,
        datePattern: ['d', 'm', 'Y'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          type="tel" // https://github.com/nosir/cleave.js/issues/381
          {...input}
          {...props}
        />
      );
      break;
    case 'expiry-date':
      options = {
        date: true,
        datePattern: ['m', 'Y'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          type="tel"
          {...input}
          {...props}
        />
      );
      break;
    case 'expiry-month':
      options = {
        date: true,
        datePattern: ['m'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          type="tel"
          {...input}
          {...props}
        />
      );
      break;
    case 'expiry-year':
      options = {
        date: true,
        datePattern: ['Y'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          type="tel"
          {...input}
          {...props}
        />
      );
      break;
    case 'cleave':
      component = (
        <Cleave
          style={style}
          type="tel"
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={cleaveOptions}
          {...input}
          {...props}
        />
      );
      break;
    case 'checkbox':
      component = <Checkbox style={style} className={classes} {...input} {...props} {...complexProps} />;
      break;
    case 'radio':
      component = <Radio style={style} className={classes} value={value} {...input} {...props} {...complexProps} />;
      break;
    default:
      component = (
        <FormControl
          style={style}
          type={type}
          placeholder={placeholder}
          componentClass={componentClass}
          className={classes}
          {...input}
          {...props}
          {...complexProps}
        />
      );
      break;
  }

  // meta.error = 'Error test';

  return (
    <div className={meta.touched && meta.error ? 'has-error' : ''}>
      {component}
      {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
    </div>
  );
};

export default FieldFormControl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/FieldFormControl/index.tsx